export default __webpack_public_path__ + "static/media/teamwork.a310ec23.png";